import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import { AppErrorBoundary } from './components/AppErrorBoundary'
import './styles/globals.css'
import { applyBrandTheme } from './lib/applyBrandTheme'
import { queryClient } from './services/queryClient'
import { installIdentityChangeReset } from './services/identityChange'
import { installFeedbackContext } from './services/feedbackContext/capture'

applyBrandTheme()
// SA-922: every identity change (View-as, logout, a failed refresh) clears the
// previous person's browser state at the swap.
installIdentityChangeReset()

// Data router with a single splat route (documented incremental-adoption
// shape): App's declarative <Routes> tree keeps matching unchanged as
// descendant routes inside "*", while the data router enables useBlocker
// (useUnsavedChangesGuard's in-app navigation blocking). The errorElement is
// the app's only error boundary — one boundary covers every route (SA-235).
const router = createBrowserRouter([
  { path: '*', element: <App />, errorElement: <AppErrorBoundary /> },
])

// SA-1304: the feedback context ring (recent pages, actions and errors, cleaned through the
// allowlist). Sends nothing; the Help & feedback panel takes a snapshot when someone reports.
installFeedbackContext(router)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
